// Shared Plotly config so every dashboard chart offers the same, discoverable interactions:
// a visible toolbar with a "download as PNG" button (previously hidden entirely via
// displayModeBar:false, so there was no way to capture/export a chart), and box-zoom/pan tools
// with the noisy, not-useful-here ones (lasso/box-select, autoscale) removed.
const plotlyChartConfig = (filename: string): Partial<Plotly.Config> => ({
  displayModeBar: true,
  displaylogo: false,
  modeBarButtonsToRemove: ['lasso2d', 'select2d', 'autoScale2d'],
  toImageButtonOptions: {
    format: 'png',
    filename,
    scale: 2,
  },
});

export default plotlyChartConfig;
